import { UpcomingMatchesSchema } from '@/views/sports/UpcomingMatches/styles/UpcomingMatches.styles';

export const upcomingMatchesStyles: UpcomingMatchesSchema = {
  pageHeader: {
    fontSize: 'xl',
    fontFamily: 'accent',
    letterSpacing: '1px',
    fontWeight: 'bold',
    color: 'white',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    mb: ['0', null, '2'],
    textTransform: 'uppercase',
  },
  stackWrapper: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    p: '0',
  },
  headingIcon: {
    sx: {
      color: 'beta.300',
    },
  },
  hStackWrapper: {
    justifyContent: 'flex-end',
  },
  sortByText: {
    fontSize: '2xs',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: 'white',
  },
  scrollButtonGroup: {
    bg: 'blackAlpha.300',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
    variant: 'filter',
  },
  flexRenderSortingMobile: {
    justify: 'flex-end',
  },
  loadingSkeletonText: {
    my: '4',
    noOfLines: 2,
    spacing: '4',
    skeletonHeight: '2',
  },
  mainStackWrapper: {
    spacing: '4',
  },
  mainStackInner: {
    spacing: '4',
  },
  heading: {
    alignItems: 'center',
    display: 'flex',
    fontSize: 'md',
    gap: '1',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
    fontFamily: 'accent',
    letterSpacing: '1px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: 'white',
  },
  propositionButton: {
    variant: 'odds',
    flex: '1',
    height: '38px',
    display: 'initial',
  },
  boxSportWrapper: {
    display: 'none',
  },
  buttonSport: {
    pr: '30px',
    sx: {
      '&:after': {
        content: '""',
        position: 'absolute',
        display: 'block',
        border: '1px',
        borderColor: 'white',
        boxSize: '2.5',
        top: '7px',
        right: '2.5',
        borderRadius: 'full',
        pr: '2',
      },
    },
  },
  buttonAllSports: {
    _active: {
      bg: 'alpha.100',
      color: 'white',
      border: 'none',
      '&:after': {
        display: 'none',
      },
    },
  },
  segmentedButtonSortByTime: {
    color: 'white',
    _hover: {
      color: 'white',
    },
    _active: {
      bg: 'beta.300',
      color: 'alpha.600',
    },
  },
  segmentedButtonSortBySport: {
    color: 'white',
    _hover: {
      color: 'white',
    },
    _active: {
      bg: 'beta.300',
      color: 'alpha.600',
    },
  },
};
